import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import BaseProductCallout from '~/shared/components/ProductCallout';
import { isSavage } from '~/shared/utils/brandNameHelper';
import useProductCallout, { Callout } from '~/shared/utils/useProductCallout';
import { useProductContext } from '~/techstyle-shared/react-components';

// list of specified & prioritized options passed to useProductCallout to dictate the types returned
const flytPdpPriorityList = [
  Callout.SOLD_OUT_KEEP_ON_GRID,
  Callout.LAST_CHANCE,
  Callout.YITTY_COLLECTION,
  Callout.DELAYED_SHIPPING,
  Callout.EU_EXCLUSIVE,
  Callout.KHLOES_PICK,
  Callout.PLATINUM_EXCLUSIVE,
  Callout.KATES_EDIT,
  Callout.ECO_STYLE,
  Callout.BACK_IN_STOCK,
  Callout.GOLD_ELITE_EXCLUSIVE,
  Callout.NEW,
];

// STYLED COMPONENTS
const CalloutWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  ${({ theme }) => theme.pdpMarketingCallout}
`;

const ProductCallout = styled(BaseProductCallout)`
  background-color: ${({ theme, type }) =>
    type === 'YITTY_COLLECTION'
      ? theme.colors.pdpCalloutYittyCollection
      : theme.colors.pdpCalloutBg};
  border-radius: 4px;
  color: ${({ theme, type }) =>
    type === 'YITTY_COLLECTION'
      ? theme.colors.textLight
      : theme.colors.pdpCalloutText};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: ${-0.43 / 12}em;
  line-height: 1.67;
  padding: 0 8px;
  text-transform: uppercase;
`;

const ProductDetailMarketingCallout = ({
  product: productFromProps,
  ...props
}) => {
  const productFromContext = useProductContext();
  const product = productFromProps || productFromContext;

  const params = {
    product,
  };

  if (!isSavage()) {
    params.callouts = flytPdpPriorityList;
  }

  const callout = useProductCallout(params);

  return (
    callout && (
      <CalloutWrapper data-autotag="pdp-marketing-callout" {...props}>
        <ProductCallout type={callout.type} value={callout.value} />
      </CalloutWrapper>
    )
  );
};

ProductDetailMarketingCallout.propTypes = {
  product: PropTypes.object,
};

export default ProductDetailMarketingCallout;
